  if (!customElements.get('td-freeswatch-popup')) {
  class TdFreeswatchPopup extends HTMLElement {
    constructor() {
      super();
      this.popupTriggers = this.querySelectorAll('.open_modal_fabric');
    }

    connectedCallback() {
      this.popupTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openPopup(trigger);
        });
      });

      this.querySelectorAll('.freeswatch-add-to-cart').forEach(btn => {
        btn.addEventListener('click', () => {
          if (this.isLoading()) return;
          const checkbox = this.querySelector('input[type="checkbox"]');
          if (checkbox && !checkbox.checked) {
            this.setLoading(true);
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const modal = btn.closest('td-modal');
          if (modal && typeof modal.closeModal === 'function') {
            modal.closeModal();
          }
        });
      });

      this.querySelectorAll('.freeswatch-fabric-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          if (this.isLoading()) return;
          const checkbox = this.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            this.setLoading(true);
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      this.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          this.updateActiveState(e.target);
        });
      });
    }

    openPopup(trigger) {
      const popupId = trigger.getAttribute('href');
      const modal = Array.from(this.querySelectorAll('td-modal')).find(tdModal => {
        const modalContent = tdModal.querySelector('.materialModal');
        return modalContent && ('#' + modalContent.id) === popupId;
      });
      if (modal && typeof modal.openModal === 'function') {
        modal.openModal();
      }
    }

    closePopup(element) {
      const modal = element.closest('td-modal');
      if (modal && typeof modal.closeModal === 'function') {
        modal.closeModal();
      }
    }

    isLoading() {
      return !!document.querySelector('.freeswatch-fabric-block.td-fabric-loading');
    }

    setLoading(isLoading) {
      const fabricBlock = this.closest('.freeswatch-fabric-block');
      if (fabricBlock) {
        if (isLoading) {
          fabricBlock.classList.add('td-fabric-loading');
        } else {
          fabricBlock.classList.remove('td-fabric-loading');
        }
      }
    }

    updateActiveState(checkbox) {
      const fabricBlock = checkbox.closest('.freeswatch-fabric-block');
      if (!fabricBlock || fabricBlock.classList.contains('td-fabric-loading')) return;

      if (checkbox.checked) {
        fabricBlock.classList.add('td-fabric-active');
      } else {
        fabricBlock.classList.remove('td-fabric-active');
      }
    }
  }

  customElements.define('td-freeswatch-popup', TdFreeswatchPopup);
}
